import { Trans } from "react-i18next";

import { css } from "@emotion/react";

const VisibilityInfo = () => {
    return (
        <div
            css={css({
                p: {
                    margin: "0"
                }
            })}
        >
            <Trans
                i18nKey={`Table##head title info##visibility`}
                components={{
                    1: <strong />,
                    2: <p />
                }}
            />
        </div>
    );
};

export default VisibilityInfo;
